import Vue from 'vue';
import { encodePathSegment } from '@/utils/url';

const success = response => response;

const error = () => {};

export default product => Vue.$http
    .delete(`Products/${encodePathSegment(product.id)}`)
    .then(success)
    .catch(error);




// WEBPACK FOOTER //
// ./src/services/product/del.js